module.exports = __webpack_public_path__ + "img/194.4a16059d.jpg";